import React, { useContext, useState } from 'react';
import { postBuyCourseWithSwish, postBuyGiftCardWithSwish } from '../../../../../../backend-api';
import { t } from '../../../../../../i18n';
import UrlTo from '../../../../../../url-to';
import { isMobile } from '../../../../../../utilities';
import getTimeZoneName from '../../../../../../utilities/getTimeZoneName';
import SwishLogoBanner from '../../swish-logo-banner';
import CourseCheckoutError from '../../../course-checkout-error';
import { useHistory } from 'react-router-dom';
import { Button, Loader } from '../../../../../../components';
import CheckoutContext from '../../../checkout-context';
import './styles.scss';

function getErrorMessage(e) {
  switch (e.response?.data.errorCode) {
    case CourseCheckoutError.COURSE_ALREADY_BOUGHT:
      return 'DIGITAL_COURSES.CHECKOUT.ERROR.ALREADY_BOUGHT';
    case CourseCheckoutError.SWISH_PAYMENT_ALREADY_IN_PROGRESS:
      return 'DIGITAL_COURSES.CHECKOUT.ERROR.SWISH_PAYMENT_ALREADY_IN_PROGRESS';
    default:
      return 'SERVER_ERROR';
  }
}

function deepLinkToSwishAppOrFallback(deeplinkUrl, fallbackAction) {
  if (!isMobile()) {
    fallbackAction();
    return;
  }
  window.location.href = deeplinkUrl;
  setTimeout(fallbackAction, 500);
}

const SwishPaymentForm = ({ courseId, email, name }) => {
  const history = useHistory();
  const [isPaying, setPaying] = useState(false);
  const [paymentError, setPaymentError] = useState(null);
  const { isCoursePayment } = useContext(CheckoutContext);

  const handlePayPressed = async () => {
    setPaying(true);
    setPaymentError(null);
    try {
      const timeZoneName = getTimeZoneName();
      const { paymentId, token } = isCoursePayment
        ? await postBuyCourseWithSwish(courseId, { email, timeZoneName })
        : await postBuyGiftCardWithSwish({ email, timeZoneName });
      const nextUrl = isCoursePayment
        ? UrlTo.coursesSwishCheckoutResult(courseId, email, name, paymentId)
        : UrlTo.coursesGiftCardSwishCheckoutResult({ email, name, paymentId });
      const callbackAbsoluteUrl = encodeURIComponent(`${window.location.protocol}//${window.location.host}${nextUrl}`);
      const deeplinkUrl = `swish://paymentrequest?token=${token}&callbackurl=${callbackAbsoluteUrl}`;
      deepLinkToSwishAppOrFallback(deeplinkUrl, () => {
        history.push(nextUrl);
      });
    } catch (e) {
      setPaymentError(getErrorMessage(e));
    } finally {
      setPaying(false);
    }
  };

  return (
    <div className="courses-swish-checkout">
      <SwishLogoBanner />
      <div className="courses-swish-checkout__payment-form">
        <div>{t('DIGITAL_COURSES.CHECKOUT.SWISH_DESCRIPTION')}</div>
        {!!paymentError && <p className="courses-swish-checkout__error">{t(paymentError)}</p>}
        <Button
          type="green"
          text={t('DIGITAL_COURSES.CHECKOUT.PAY_NOW')}
          className="courses-swish-checkout__pay-button"
          onClick={handlePayPressed}
          disabled={isPaying}
        />
        {isPaying && <Loader />}
      </div>
    </div>
  );
};

export default SwishPaymentForm;
